var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 50",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.884
    },
    fill: "#fefffe",
    d: "M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 4.90814,0.643141 5.57481,1.64314 6.5,2.5C 17.7508,9.3749 28.9175,16.3749 40,23.5C 40.4997,15.5069 40.6664,7.50694 40.5,-0.5C 42.5,-0.5 44.5,-0.5 46.5,-0.5C 46.9081,0.643141 47.5748,1.64314 48.5,2.5C 59.8613,9.51102 71.1946,16.511 82.5,23.5C 82.5,24.1667 82.5,24.8333 82.5,25.5C 71.1946,32.489 59.8613,39.489 48.5,46.5C 47.5748,47.3569 46.9081,48.3569 46.5,49.5C 44.5,49.5 42.5,49.5 40.5,49.5C 40.6664,41.4931 40.4997,33.4931 40,25.5C 28.9175,32.6251 17.7508,39.6251 6.5,46.5C 5.57481,47.3569 4.90814,48.3569 4.5,49.5C 2.83333,49.5 1.16667,49.5 -0.5,49.5C -0.5,32.8333 -0.5,16.1667 -0.5,-0.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/FastForward.5ae4df966e4d7f5e6e0fc73c0ee83ef4.svg";
export { ForwardRef as ReactComponent };